/**
 * RunAI OS — Menu Bar (macOS style)
 * Composed from: Logo + Items + Status + User
 */
import type { MenuItem } from './dockConfig'
import MenuBarItems from './MenuBarItems'
import MenuBarLogo from './MenuBarLogo'
import MenuBarStatus from './MenuBarStatus'
import MenuBarUser from './MenuBarUser'
import { useMenuBarData } from './useMenuBarData'

interface Props {
  onMenuClick?: (item: MenuItem) => void
}

export default function MenuBar({ onMenuClick }: Props) {
  const { agentStats, flzBalance } = useMenuBarData()

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      height: '30px',
      background: 'var(--os-mb-bg)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      padding: '0 14px',
      fontSize: '12px',
      borderBottom: '1px solid var(--os-border)',
      position: 'relative',
      zIndex: 100,
      userSelect: 'none',
      flexShrink: 0,
    }}>
      <MenuBarLogo />
      <MenuBarItems onMenuClick={onMenuClick} />
      <MenuBarStatus agentStats={agentStats} flzBalance={flzBalance} />
      <MenuBarUser />
    </div>
  )
}
